import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";


export const getAllProjects = (state: RootState) => state.projects;

export const projects = createSelector(getAllProjects, (state) => {
    return state.entities;
}
);

//filter project by projectId
export const getProjectById = (projectId: string) => {
    return createSelector(getAllProjects, (state) => {
        return state?.entities?.find((project) => project?.projectId === projectId);
    });
};


export const projectsLoadingState = createSelector(getAllProjects, (state) => {
    return state.loading;
}
);

export const addProjects = (state: RootState) => state.projects;


export const addProjectLoadingState = createSelector(addProjects, (state) => {
    return state.loading;
});

export const addProjectErrorState = createSelector(addProjects, (state) => {
    return state.error;
});

export const addProjectFullfilledState = createSelector(addProjects, (state) => {
    return state.fulfilled;

});
export const addProjectMessageState = createSelector(addProjects, (state) => {
    return state.message;


});

export const editProject = (state: RootState) => state.projects;

export const editProjectLoadingState = createSelector(editProject, (state) => {
    return state.loading;
}
);

export const editProjectErrorState = createSelector(editProject, (state) => {
    return state.error;
}
);

export const editProjectFullfilledState = createSelector(editProject, (state) => {
    return state.fulfilled;
}
);

export const editProjectMessageState = createSelector(editProject, (state) => {
    return state.message;
}
);

export const deleteproject = (state: RootState) => state.projects;

export const deleteProjectLoadingState = createSelector(deleteproject, (state) => {
    return state.loading;
}
);

export const deleteProjectErrorState = createSelector(deleteproject, (state) => {
    return state.error;
}
);

export const deleteProjectFullfilledState = createSelector(deleteproject, (state) => {
    return state.fulfilled;
}
);

export const deleteProjectMessageState = createSelector(deleteproject, (state) => {
    return state.message;
}
);

//Brand voice selectors
export const getbrandVoice = (state: RootState) => state.projects;

export const brandVoice = createSelector(getbrandVoice, (state) => {
    return state.brandVoice;
}
);

export const brandVoiceLoadingState = createSelector(getbrandVoice, (state) => {
    return state.loading;
}
);

export const brandVoiceErrorState = createSelector(getbrandVoice, (state) => {
    return state.error;
}

);

export const brandVoiceFullfilledState = createSelector(getbrandVoice, (state) => {
    return state.fulfilled;
}

);

export const brandVoiceMessageState = createSelector(getbrandVoice, (state) => {
    return state.message;
}
);

const saveBrandVoice = (state: RootState) => state.projects;

export const saveBrandVoiceLoadingState = createSelector(saveBrandVoice, (state) => {
    return state.loading;
}
);

export const saveBrandVoiceErrorState = createSelector(saveBrandVoice, (state) => {
    return state.error;
}
);

export const saveBrandVoiceFullfilledState = createSelector(saveBrandVoice, (state) => {
    return state.fulfilled;
}
);

export const saveBrandVoiceMessageState = createSelector(saveBrandVoice, (state) => {
    return state.message;
}
);

// edit brand voice selectors

const editBrandVoice = (state: RootState) => state.projects;

export const editBrandVoiceLoadingState = createSelector(editBrandVoice, (state) => {
    return state.loading;
}
);

export const editBrandVoiceErrorState = createSelector(editBrandVoice, (state) => {
    return state.error;
}

);

export const editBrandVoiceFullfilledState = createSelector(editBrandVoice, (state) => {
    return state.fulfilled;
}

);

export const editBrandVoiceMessageState = createSelector(editBrandVoice, (state) => {
    return state.message;
}
);

// delete brand voice selectors

const deleteBrandVoice = (state: RootState) => state.projects;

export const deleteBrandVoiceLoadingState = createSelector(deleteBrandVoice, (state) => {
    return state.loading;
}
);

export const deleteBrandVoiceErrorState = createSelector(deleteBrandVoice, (state) => {
    return state.error;
}

);

export const deleteBrandVoiceFullfilledState = createSelector(deleteBrandVoice, (state) => {
    return state.fulfilled;
}
);

export const deleteBrandVoiceMessageState = createSelector(deleteBrandVoice, (state) => {
    return state.message;
}
);

// save companyDetails selectors

const saveCompanyDetails = (state: RootState) => state.projects;

export const saveCompanyDetailsLoadingState = createSelector(saveCompanyDetails, (state) => {
    return state.loading;
}
);

export const saveCompanyDetailsErrorState = createSelector(saveCompanyDetails, (state) => {
    return state.error;
}

);

export const saveCompanyDetailsFullfilledState = createSelector(saveCompanyDetails, (state) => {
    return state.fulfilled;
}

);

export const saveCompanyDetailsMessageState = createSelector(saveCompanyDetails, (state) => {
    return state.message;
}
);
// save exludedLinks selectors

const saveExcludedLinks = (state: RootState) => state.projects;

export const saveExcludedLinksLoadingState = createSelector(saveExcludedLinks, (state) => {
    return state.loading;
}
);

export const saveExcludedLinksErrorState = createSelector(saveExcludedLinks, (state) => {
    return state.error;
}

);

export const saveExcludedLinksFullfilledState = createSelector(saveExcludedLinks, (state) => {
    return state.fulfilled;
}

);

export const saveExcludedLinksMessageState = createSelector(saveExcludedLinks, (state) => {
    return state.message;
});

// save project instructions selectors
const saveProjectInstructions = (state: RootState) => state.projects;

export const saveProjectInstructionsLoadingState = createSelector(saveProjectInstructions, (state) => {
    return state.loading;
});

export const saveProjectInstructionsErrorState = createSelector(saveProjectInstructions, (state) => {
    return state.error;
});

export const saveProjectInstructionsFullfilledState = createSelector(saveProjectInstructions, (state) => {
    return state.fulfilled;
});

export const saveProjectInstructionsMessageState = createSelector(saveProjectInstructions, (state) => {
    return state.message;
});